<template>
  <div class="w100 Overview">
    <div class="search-top" v-loading="Loading">
      <div>
        <el-select
          v-model="searchData.SupplierId"
          filterable
          clearable
          style="width: 260px"
          placeholder="请选择供应商"
        >
          <el-option
            v-for="item in SupplierData"
            :key="item.Id"
            :label="item.title"
            :value="item.Id"
          ></el-option>
        </el-select>
        <el-select
          v-model="searchData.DeviceType"
          filterable
          clearable
          style="width: 260px; margin-left: 10px"
          placeholder="请选择设备分类"
        >
          <el-option
            v-for="item in TreeData"
            :key="item.Id"
            :label="item.DicName"
            :value="item.Id"
          ></el-option>
        </el-select>
        <el-button
          type="primary"
          @click="getDataList"
          style="margin-left: 10px"
        >
          查询</el-button
        >
      </div>
    </div>
    <el-table
      class="table-ove"
      :data="Data"
      style="width: 100%"
      header-row-class-name="table-tit"
      v-loading="Loading"
    >
      <el-table-column
        type="index"
        label="序号"
        width="55"
        align="center"
      ></el-table-column>

      <el-table-column
        prop="SupplierName"
        label="供应商名称"
        align="center"
        width="360"
      >
      </el-table-column>
      <el-table-column prop="CategoryName" label="设备分类" align="center">
      </el-table-column>
      <el-table-column
        prop="SubmissionRate"
        label="提交率"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <el-progress
            :text-inside="true"
            :stroke-width="16"
            :percentage="scope.row.SubmissionRate"
          ></el-progress>
        </template>
      </el-table-column>
      <el-table-column
        prop="PassRate"
        label="通过率"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <el-progress
            :text-inside="true"
            :stroke-width="16"
            :percentage="scope.row.PassRate"
          ></el-progress>
        </template>
      </el-table-column>
      <el-table-column prop="DevicesQty" label="设备数量" align="right">
      </el-table-column>
      <el-table-column prop="InforQty" label="资料数量" align="right">
      </el-table-column>
      <el-table-column prop="RejectedQty" label="提交数量" align="right">
      </el-table-column>
      <el-table-column prop="PassQty" label="通过数量" align="right">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import * as echarts from 'echarts'

export default {
  data() {
    return {
      Loading: false,
      Data: [],
      searchData: {
        SupplierId: '',
        DeviceType: '',
      },

      SupplierData: [],
      TreeData: [],
    }
  },
  props: {
    pId: {
      type: String,
      default: '',
    },
    isloadingPdf: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  methods: {
    getSupplierData() {
      this.$http
        .post(
          `/Base_ProjectWork/Base_ProjectSupplier/GetProjectSupplierTree?ProjectId=${this.pId}&Type=0`
        )
        .then((res) => {
          if (res.Success) {
            this.SupplierData = res.Data
          }
        })
    },
    getTreeData() {
      this.$http
        .post(
          `/Base_ProjectManage/Project_DictionaryMain/GetDevcieDictionaryMain?`
        )
        .then((res) => {
          if (res.Success) {
            this.TreeData = res.Data
          }
        })
    },
    getDataList() {
      this.Loading = true
      this.$http
        .post(
          '/Base_ProjectWork/Base_Project/GetProjectSupplierCategoryStatistic',
          {
            Search: {
              ProjectId: this.pId,
              ...this.searchData,
            },
          }
        )
        .then((res) => {
          this.Loading = false
          if (res.Success) {
            this.Data = res.Data || []
            this.$nextTick(() => {
              this.Data.forEach((item, index) => {
                this.createGaugeChart(
                  `submitChart-${index}`,
                  item.SubmissionRate,
                  '#409eff'
                )
                this.createGaugeChart(
                  `passChart-${index}`,
                  item.PassRate,
                  '#67C23A'
                )
              })
            })
          }
        })
    },

    createGaugeChart(containerId, value, color) {
      const container = document.getElementById(containerId)
      if (!container) return

      const chart = echarts.init(container)
      const option = {
        series: [
          {
            type: 'gauge', // 图表类型为仪表盘
            // startAngle:180,
            // endAngle:360,
            min: 0, // 仪表盘最小值
            max: 100, // 仪表盘最大值
            //分割数
            splitNumber: 4, // 仪表盘刻度分割段数
            radius: '75%',
            center: ['50%', 26],
            progress: {
              // 进度条配置
              show: true, // 是否显示进度条
              width: 3, // 进度条宽度
              itemStyle: {
                // 进度条样式
                color: color, // 进度条颜色
              },
              roundCap: true, // 进度条两端是否圆角
            },
            axisLine: {
              // 仪表盘轴线配置
              lineStyle: {
                width: 3, // 轴线宽度
              },
            },
            // 刻度样式。
            axisTick: {
              // 刻度线配置
              show: true, // 是否显示刻度线
              distance: 1, // 刻度线与轴线距离
              length: 1, // 刻度线长度
              lineStyle: {
                // 刻度线样式
                width: 1, // 刻度线宽度
                color: '#999', // 刻度线颜色
              },
            },
            splitLine: {
              // 分割线配置
              distance: 1, // 分割线与轴线距离
              show: true, // 是否显示分割线
              length: 1, // 分割线长度
              lineStyle: {
                // 分割线样式
                width: 1, // 分割线宽度
                color: '#999', // 分割线颜色
              },
            },
            axisLabel: {
              // 轴标签配置
              distance: 2, // 标签与轴线距离
              color: '#999', // 标签文字颜色
              fontSize: 8, // 标签文字大小
            },
            pointer: {
              // 指针配置
              width: 2, // 指针宽度
              length: '70%', // 指针长度，占仪表盘半径的百分比
              itemStyle: {
                // 指针样式
                color: color, // 指针颜色
              },
            },
            detail: {
              // 仪表盘详情配置（显示数值）
              formatter: '{value}%', // 数值格式化，显示为百分比
              textStyle: {
                // 数值文字样式
                fontSize: 12, // 数值文字大小
                color: '#333', // 数值文字颜色
              },
              offsetCenter: [0, 25], // 数值相对于仪表盘中心的偏移位置
            },
            data: [
              // 仪表盘数据
              {
                value: value || 0, // 实际数值
              },
            ],
          },
        ],
      }

      chart.setOption(option)
      chart.resize()
    },
  },
  mounted() {
    // this.initCharts()
  },
  created() {
    this.getTreeData()
    this.getSupplierData()
    this.getDataList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .table-tit {
  font-weight: 1000;
  font-size: 16px;
  color: #000;
  height: 40px;
}
.table-ove {
  margin-bottom: 20px;
}
.Overview {
  padding: 0 10px;
}
::v-deep .el-table__body-wrapper {
  .el-table__cell {
    font-size: 14px;
  }
}
</style>
